export default "__VITE_ASSET__bf1e17e6__"